import {Box, Stack, VStack} from "@chakra-ui/react";
import React from "react";

export const CardRow = ({left, right}: any) => {
    
  return <Stack direction={["column", "column", "row"]} alignItems={["start", "start", "center"]} spacing={"4"}
    w={"full"}>
    <VStack alignItems={"start"} spacing={"0"} w={"md"}>
      {left && left()}
    </VStack>
    <Box w={"full"} maxW={"md"}>
      {right && right()}
    </Box>
  </Stack>
}